import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, ViewChild, Output, EventEmitter, OnInit } from '@angular/core';
import { Router, NavigationEnd  } from '@angular/router';
import { PayrollService } from 'src/app/shared/services/payrollservices/payroll.service';
import { FormsModule } from '@angular/forms';
import Swal from 'sweetalert2';
import { Location } from '@angular/common';
declare let $: any;

@Component({
  selector: 'app-past-payroll',
  imports: [CommonModule],
  templateUrl: './past-payroll.component.html',
  styleUrl: './past-payroll.component.css',
})
export class PastPayrollComponent implements OnInit {
  public showSpinner = false
  userId: any;
  detailData: any;

  currentPage = 1;
  totalPages = 0;
  pageNumbers: number[] = [];
  showSkeleton = true;
  selectedUser: any;
  currentYear: number = new Date().getFullYear();
  months: string[] = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  selectedYear: number | null = null;
  years: number[] = [];
  selectedMonth: number | null = null;
history: string[] = [];
currentUrl = '';
previousUrl = '';

  @Output() monthSelected = new EventEmitter<{ year: number, month: number }>();

  newChartOptions: any = {
    chart: {},
    labels: [],
    colors: [],
    plotOptions: {},
    legend: {},
    dataLabels: {},
    stroke: {}
  };

  newChartData: any[] = [];
  departmentsPayroll = [
    { department: 'HR', total: 50000 },
    { department: 'Finance', total: 75000 },
    { department: 'IT', total: 100000 },
    { department: 'Web', total: 50000 },
    { department: 'Mobile', total: 75000 },
    { department: 'BD', total: 100000 }
  ];
  releasedsummaryPercentage: any;
  summaryTotaldeduction: any;
  summaryFinalsettlement: any;
  summaryTotalgross: any;
  summaryPendingTotal: any;
  summaryTotalReleased: any;
  currentMonth: number = new Date().getMonth() + 1;
  lastPage: any;
  userList: any;
  selectedPayroll: any;
  graphSkeleton = true;
  summarySkeleton = true;
  departmentSkeleton = true;
  leave_modification_Date: any;
  user_Roles: any;
  payrollList: any;
  modalcurrentYear: number = new Date().getFullYear();
  from: any;
  prevYear() {
    this.modalcurrentYear--;
  }

  nextYear() {
    this.modalcurrentYear++;
  }

  selectMonth(monthIndex: number) {
    this.selectedMonth = monthIndex;
    this.monthSelected.emit({ year: this.currentYear, month: monthIndex + 1 });

  }
  filters = {
    name: '',      // first+last name search
    role_id: ''    // role filter
  };

  constructor(
    public payrollService: PayrollService,
    public router: Router,
    private location: Location,

  ) {
 
  }
  ngOnInit() {
    
    const state = history.state;
    this.from = history.state.from;
    console.log('User ID from state:', state.user_id);
    if (state.user_id) {
      this.userId = state.user_id;
      this.getUserPayrollDetail(this.userId);
    }
  }

  getUserPayrollDetail(user_id: any, page = 1) {
    const payload = { user_id: user_id, per_page: 10, page: page };
    this.payrollService.getuserHistory(payload)
      .then((value: any) => {
        this.detailData = value?.data;
        this.currentPage = value.data?.monthly_salaries?.current_page || 1;
        this.totalPages = value.data?.monthly_salaries?.last_page || 1;
        this.generatePageNumbers();
        this.showSkeleton = false;
      });
  }


  generatePageNumbers() {
    this.pageNumbers = [];
    for (let i = 1; i <= this.totalPages; i++) {
      this.pageNumbers.push(i);
    }
  }

  goToPage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.getUserPayrollDetail(this.detailData.user_detail.id, page);
  }

  goPrev() {
    if (this.currentPage > 1) this.goToPage(this.currentPage - 1);
  }

  goNext() {
    if (this.currentPage < this.totalPages) this.goToPage(this.currentPage + 1);
  }

  // Helper function to format date (optional)
  formatDate(dateStr: string): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;
  }
  editCase(data: any) {
    
    const currentMonthInt = new Date().getMonth() + 1;
    const currentMonthYear = new Date().getFullYear();
    const currentMonthChar = new Date().toLocaleString('default', { month: 'long' });
    this.router.navigate(['/manual-payroll'], {
      state: {
        user: data,
        monthInt: currentMonthInt,
        monthYear: currentMonthYear,
        monthChar: currentMonthChar
      }
    });
  }


  setSelectedUser(user: any) {
    this.selectedUser = user;
  }
  userPayrolselectMonth(index: number) {
    
    if (!this.selectedUser) return;

    this.selectedMonth = index;

    const monthInt = index + 1;
    const monthChar = this.months[index];
    const monthYear = this.modalcurrentYear;

    // close modal
    $('#userpayrollModal').modal('hide');

    // navigate
    this.router.navigate(['/manual-payroll'], {
      state: {
        user: this.selectedUser,
        monthInt: monthInt,
        monthChar: monthChar,
        monthYear: monthYear
      }
    });

  }
goBack() {
  // Navigate based on actual previous URL
  if (this.from === 'employee-salary-info') {
    this.router.navigate(['/employee-salary-info']);
  } else if (this.from === 'payroll-sheet') {
    this.router.navigate(['/employee-salary-info']);
  } else {
    this.location.back(); // fallback
  }
}



  showSlip(data: any, fullData:any) {
    this.router.navigate(['/payroll-sheet'], {
      state: {
        data: data,        // your data here
         user: fullData,  
        from: this.router.url
      },
      skipLocationChange: false
    });
  }



  

}
